
<script lang="ts">

    import {Sheet, emptySheet, getKey, type Player, homeLetters, visitingLetters, type SheetScore} from './src/types';
    import {push, querystring} from 'svelte-spa-router';
    import {getTeamsAndPlayers, saveSheet} from './src/client'
    import MatchSet from './MatchSet.svelte';
    import MatchSetDouble from './MatchSetDouble.svelte'; 
    import {onMount, getContext} from 'svelte';
    import {sheets} from './src/sheetStore'
    import {getSheet} from './src/client';
    import {parse,format} from 'date-fns';
    import Fa from 'svelte-fa/src/fa.svelte';
    import { faTrophy, faPen, faFloppyDisk, faBroom } from '@fortawesome/free-solid-svg-icons/index.js';
    import AutoComplete from "simple-svelte-autocomplete"
    import ErrorDialog from './ErrorDialog.svelte';
    import type { Context } from 'svelte-simple-modal';
    import Switch from './Switch.svelte'
    
    
    const modal = getContext<Context>('simple-modal');
    
    const setAuthenticated = getContext<(b: boolean) => void>('setAuthenticated');


    let teams: string[] = [];
    let teamsAndPlayers: {[team:string]:Player[]} = {}
    let homePlayers : string[] = [];
    let visitingPlayers : string[] = [];

    let homeDouble:string = "";
    let visitingDouble:string = "";

    let sheet:Sheet|undefined = undefined;

    export let params: any;

    export let id : number;

    export let guest : boolean;

    let total_home_score = 0;
    let total_visiting_score = 0;

    let readonly: boolean = false;
    let editing : boolean = false;

    let getPlayerName = (team:any,letter:string):string => {
        if (letter) {
            return team.hasOwnProperty(letter) ? team[letter]?.name : '';
        }
        return '';
    }

    

    let mountGuest = async () => {        
        const s = await getSheet(id.toString());
        
        if (s.authorized) {
            guest = true;
            readonly = true;
            sheet = s.result;    
            if (!sheet.scores.double_home) {
                sheet.scores.double_home = ['',''];
            }
            if (!sheet.scores.double_visiting) {
                sheet.scores.double_visiting = ['',''];
            }
            homeDouble = getPlayerName(sheet.home,sheet.scores.double_home[0])+' - '+getPlayerName(sheet.home,sheet.scores.double_home[1]);            
            visitingDouble = sheet.visiting[sheet.scores.double_visiting[0]]?.name+' - '+getPlayerName(sheet.visiting,sheet.scores.double_visiting[1]);
            editing = false;            
        }
    }

    onMount(async() => {
        if (guest) {
           await mountGuest();
           return;
        }
        let tp = await getTeamsAndPlayers();
        if (tp.authorized) {
            teamsAndPlayers = tp.result;
        }
        else {
            setAuthenticated(false);
            push('/login');
            return;
        }
        teams = Object.keys(teamsAndPlayers);
        if (params && params.id) {
            
            const key = `${params.team}/${params.visiting}/${params.date}`;
            
            if (!sheet) {                
                    
                    const s = await getSheet(params.id)
                    if (s.authorized) {
                        sheet = s.result;
                    }
                    else {
                        setAuthenticated(false);
                        push('/login');
                        return;
                    }
                    if (sheet) {
                    }
                    else {
                        sheet=emptySheet;
                        return;
                    }                    
                }
                if (!sheet.scores.double_home) {
                    sheet.scores.double_home = ['',''];
                }
                if (!sheet.scores.double_visiting) {
                    sheet.scores.double_visiting = ['',''];
                }
                
                homeDouble = getPlayerName(sheet.home,sheet.scores.double_home[0])+' - '+getPlayerName(sheet.home,sheet.scores.double_home[1]);            
                visitingDouble = getPlayerName(sheet.visiting,sheet.scores.double_visiting[0])+' - '+getPlayerName(sheet.visiting,sheet.scores.double_visiting[1]);
                if ($querystring.includes('edit=true')) {
                    readonly = false;
                    editing = true;
                }
                else {
                    readonly = true;
                    editing = false;
                }
                return;
        }
        readonly = false;
        sheet = emptySheet;
    })
    
let isNullOrEmpty = (s : string) => {
    return s === undefined || s === null || s.length == 0;
}

let incompleteMatch = (matchName : string, sheet: Sheet) => {
    let homePlayerName = getPlayerName(sheet.home, matchName[0])
    let visitingPlayerName = getPlayerName(sheet.visiting, matchName[1]);
    let incomplete = isNullOrEmpty(homePlayerName) || isNullOrEmpty(visitingPlayerName);
    return incomplete;
}

    $: {

        if (sheet) {
            if (!guest) {
                updateDoubles();
            }

            const matcheNames = ["AX","BY","CZ","AY","BZ","CX","AZ","BX","CY","Double"];
            
            total_home_score = 0;
            total_visiting_score = 0;
            for(let im=0 ;im < 10 ;im++) {
                const matchName = matcheNames[im];
                
                let match = sheet.scores[matchName as keyof SheetScore] as SheetMatch; 
                
                if (match) {
                    let homePlayerName = getPlayerName(sheet.home,matchName[0])
                    let visitingPlayerName = getPlayerName(sheet.visiting,matchName[1]);

                    if (isNullOrEmpty(homePlayerName) && !isNullOrEmpty(visitingPlayerName)) {
                        total_visiting_score += 1;
                        if (matchName == 'Double' && sheet.coupe) {
                            // le double compte double pour la coupe
                            match.score_visiting  += 1;
                        }
                        match.score_visiting = 1;
                    }
                    else if (!isNullOrEmpty(homePlayerName) && isNullOrEmpty(visitingPlayerName)) {
                        total_home_score += 1;
                        if (matchName == 'Double' && sheet.coupe) {
                            // le double compte double pour la coupe
                            total_home_score += 1;
                        }
                        match.score_home = 1;
                    }
                    else if (isNullOrEmpty(homePlayerName) && isNullOrEmpty(visitingPlayerName) && matchName != 'Double') {
                    }
                    else {
                        
                        let score_visiting = 0;
                        let score_home = 0;
                        let home_sets = 0;
                        let visiting_sets = 0;
                        for (let i = 0; i < 5; i++) {
                            let h = match.home[i];
                            let v = match.visiting[i]
                            if (h > v && h >= 11 && h-v >=2) {
                                home_sets++;
                            }
                            else if (v > h && v >= 11 && v-h >=2) {
                                visiting_sets++;
                            }
                        }
                        if (home_sets >= 3) {   
                            if (matchName == 'Double' && sheet.coupe) {
                                // le double compte double pour la coupe
                                score_home += 1;
                                total_home_score = total_home_score + 1;
                            }
                            score_home += 1;
                            total_home_score = total_home_score + 1;
                        }
                        else if (visiting_sets >= 3) {
                            if (matchName == 'Double' && sheet.coupe) {
                                // le double compte double pour la coupe
                                score_visiting += 1;
                                total_visiting_score = total_visiting_score + 1;
                            }
                            score_visiting += 1
                            total_visiting_score = total_visiting_score + 1;
                        }
                        else {
                        }    
                        match.score_home = score_home;
                        match.score_visiting = score_visiting;
                    }                    
                }
            }

        }        
        
    }


    let incompleteDouble = (sheet : Sheet) => {
        return isNullOrEmpty(sheet.scores.double_home[0]) || isNullOrEmpty(sheet.scores.double_home[1]) 
                || isNullOrEmpty(sheet.scores.double_visiting[0]) ||  isNullOrEmpty(sheet.scores.double_visiting[1]); 
    }
    
    let updateDoubles = () => {
        if (readonly) {
            return;
        }
        if (sheet && sheet.home && sheet.visiting && sheet.home) {
            if (sheet.scores.double_home[0] == sheet.scores.double_home[1] && sheet.scores.double_home[0] !== null && sheet.scores.double_home[0] !== undefined && sheet.scores.double_home[0] != '') {
                modal.open(
                    ErrorDialog,
                    {
                        message: `${sheet.home.name} : les joueurs de double doivent être différents !`
                    },
                    {
                        closeButton: true,
                        closeOnEsc: true,
                        closeOnOuterClick: true
                    }
                );
                sheet.scores.double_home[1] = '';
            }
            if (sheet.home.D.name && sheet.scores.double_home[0] != '' && sheet.scores.double_home[1] != '' && sheet.scores.double_home[0] != 'D' && sheet.scores.double_home[1] != 'D') {
                sheet.scores.double_home[0] = '';
                sheet.scores.double_home[1] = '';
                modal.open(
                    ErrorDialog,
                    {
                        message: `${sheet.home.name} : le joueur D - ${sheet.home.D.name} doit obligatoirement jouer le double !`
                    },
                    {
                        closeButton: true,
                        closeOnEsc: true,
                        closeOnOuterClick: true,
                    }
                );
            }

            homeDouble = getPlayerName(sheet.home,sheet.scores.double_home[0])+" - "+getPlayerName(sheet.home,sheet.scores.double_home[1])
            
            if (sheet.scores.double_visiting[0] == sheet.scores.double_visiting[1] && sheet.scores.double_visiting[0] !== null && sheet.scores.double_visiting[0] !== undefined && sheet.scores.double_visiting[0] != '') {
                modal.open(
                    ErrorDialog,
                    {
                        message: `${sheet.visiting.name} : les joueurs de double doivent être différents !`
                    },
                    {
                        closeButton: true,
                        closeOnEsc: true,
                        closeOnOuterClick: true
                    }
                );
                sheet.scores.double_visiting[1] = '';
            }
            if (sheet.visiting.W.name && sheet.scores.double_visiting[0] != '' && sheet.scores.double_visiting[1] != '' && sheet.scores.double_visiting[0] != 'W' && sheet.scores.double_visiting[1] != 'W') {
                sheet.scores.double_visiting[0] = '';
                sheet.scores.double_visiting[1] = '';
                modal.open(
                    ErrorDialog,
                    {
                        message: `${sheet.visiting.name} : le joueur W - ${sheet.visiting.W.name} doit obligatoirement jouer le double !`
                    },
                    {
                        closeButton: true,
                        closeOnEsc: true,
                        closeOnOuterClick: true
                    }
                );
                sheet.scores.double_visiting[1] = '';
            }
            visitingDouble = getPlayerName(sheet.visiting,sheet.scores.double_visiting[0])+" - "+getPlayerName(sheet.visiting,sheet.scores.double_visiting[1])           
        }
    }

    let getSheetFromStore = (key:string):Sheet|null => {
        const sheet = $sheets.filter(x => getKey(x) == key);
        if (sheet && sheet.length > 0) {
            return sheet[0];
        }
        return null;
    }

    let preSaveChecks = ():string[] => {
        let errors = [];
        if (sheet.date === undefined || sheet.date === null || sheet.date == '') {
            errors.push(`Veuillez renseigner une date pour la rencontre.`)
        }
        if (sheet.home.name === undefined || sheet.home.name === null || sheet.home.name == '') {
            errors.push(`Veuillez renseigner un nom d'équipe ABCD.`)
        }
        if (sheet.visiting.name === undefined || sheet.visiting.name === null || sheet.visiting.name == '') {
            errors.push(`Veuillez renseigner un nom d'équipe XYZW.`)
        }
        errors = errors.concat(checkSets());
        return errors;
    }

    let checkSets = (): string[] => {
        let errors:string[] = []
        const matcheNames = ["AX","BY","CZ","AY","BZ","CX","AZ","BX","CY","Double"];

        for(let im=0 ;im < 10 ;im++) {
            const matchName = matcheNames[im];
            let match = sheet.scores[matchName as keyof SheetScore] as SheetMatch;
            if (match) {          
                let score_visiting = 0;
                let score_home = 0;
                for (let i = 0; i < 5; i++) {
                    let h = match.home[i];
                    let v = match.visiting[i]
                    if (h == 0 && v == 0) {
                        continue;
                    }

                    if (h > v && h >= 11 && h-v >=2) {                                                 
                        score_home++;
                    }
                    else if (v > h && v >= 11 && v-h >=2) {
                        score_visiting++;
                    } 
                    else {
                        errors.push(`match ${matchName} : le score du set #${i+1} est incorrect (${h} - ${v}).`)
                    }                       
                }
                if (score_home >= 3) {                        
                    match.score_home = 1;
                    match.score_visiting = 0;
                    if (matchName == 'Double' && sheet.coupe) {
                        // le double compte double pour la coupe
                        match.score_home = match.score_home + 1;
                        total_home_score = total_home_score + 1;
                    }
                    total_home_score = total_home_score + 1;
                }
                else if (score_visiting >= 3) {
                    match.score_home = 0;
                    match.score_visiting = 1;

                    if (matchName == 'Double' && sheet.coupe) {
                        // le double compte double pour la coupe
                        match.score_visiting = match.score_visiting + 1;
                        total_visiting_score = total_visiting_score + 1;
                    }
                    total_visiting_score = total_visiting_score + 1;
                }
                else {
                    if (! (score_visiting == 0 && score_home == 0)) {
                        errors.push(`le score du match ${matchName} est incorrect ${score_home} - ${score_visiting}`);
                    }                    
                }   
            }
        }

        return errors;
    }

    const saveMatchSheet = async (e) => {        
        e.preventDefault();        
        const checks = preSaveChecks();        
        if (checks && checks.length > 0) {            
            modal.open(
                ErrorDialog,
                {
                    message: "<ul"+checks.map(x => `<li>${x}</li>`).join('\n')+"</ul>"
                },
                {
                    closeButton: true,
                    closeOnEsc: true,
                    closeOnOuterClick: true
                });
            return;
        }

        await saveSheet(sheet,editing);
    }

    const cleanSheet = async (e) => {
        e.preventDefault();
        sheet = emptySheet;
    }

    const editIt = (e) => {
        e.preventDefault();
        editing = true;
        readonly = false;        
    }

    const updatePlayer = (team:string, letter:string, name:string) => {
        // TODO check player unicity
        if (team == 'home') {
            if (name !== undefined && name !== null && name != '') {
                let otherLetters = homeLetters.filter(x => x != letter);
                otherLetters = otherLetters.filter(x => sheet.home[x].name == name);
                if (otherLetters !== undefined && otherLetters.length > 0) {
                    modal.open(
                    ErrorDialog,
                    {
                        message: `${sheet.home.name} : Le joueur ${name} est utilisé plusieurs fois : ${letter}, ${otherLetters.join(', ')}`
                    },
                    {
                        closeButton: true,
                        closeOnEsc: true,
                        closeOnOuterClick: true
                    }
                );
                }
            }
        }
        if (team == 'visiting') {
            if (name !== undefined && name !== null && name != '') {
                let otherLetters = visitingLetters.filter(x => x != letter);
                otherLetters = otherLetters.filter(x => sheet.visiting[x].name == name);
                if (otherLetters !== undefined && otherLetters.length > 0) {
                    modal.open(
                    ErrorDialog,
                    {
                        message: `${sheet.visiting.name} : Le joueur ${name} est utilisé plusieurs fois : ${letter}, ${otherLetters.join(', ')}`
                    },
                    {
                        closeButton: true,
                        closeOnEsc: true,
                        closeOnOuterClick: true
                    }
                );
                }
            }
        }

        if (team && letter && name) {
            const teamName = sheet[team].name;
            console.log(`searching players for >${team}< -> >${teamName}< in `,teamsAndPlayers);
            let players = teamsAndPlayers[teamName];
            if (players) {
                console.log('   =>',players);
                console.log(`searching player >${name}<`);
                let p = players.filter(x => x.name == name);
                console.log('   p =>',p);
                let player = p[0];
                console.log('   player =>',player);
                if (player) {
                    console.log(`   => ${player.ranking}`,player);
                    console.log(`setting ranking >${player.ranking}<`)
                    sheet[team][letter].rank = player.ranking;
                }
            }
        }
    }

    const updateTeam = (team : string) => {

        if (sheet.home.name == sheet.visiting.name && sheet.home.name != '') {
            if (team == 'home') {
                sheet.home.name = '';
            }
            else {
                sheet.visiting.name = '';
            }
            modal.open(
                ErrorDialog,
                {
                    message: `Les équipes doivent être différentes !`
                },
                {
                    closeButton: true,
                    closeOnEsc: true,
                    closeOnOuterClick: true
                }
            );
        }

        console.log(`changing ${team} team >${sheet[team].name}<`);
        if (team == 'home') {
            homePlayers = teamsAndPlayers.hasOwnProperty(sheet[team].name) ? teamsAndPlayers[sheet[team].name].map(x => x.name) : [];
        }
        else {
            visitingPlayers = teamsAndPlayers.hasOwnProperty(sheet[team].name) ? teamsAndPlayers[sheet[team].name].map(x => x.name) : [];
        }
    }

    const createPlayer = (player:string, letter:string, team:string) => {
        const teamName = sheet[team].name;
        console.log(`add new ${letter} ${team} player >${player}< >>${teamName}<<`);
        sheet[team][letter].name = player;
        let p: Player =  {
                name: player,
                ranking:500,
                team:teamName,
                season:''
            };
        if (teamsAndPlayers.hasOwnProperty(teamName)) {            
            teamsAndPlayers[teamName] = [...teamsAndPlayers[teamName],p];
        }
        else {
            teamsAndPlayers[teamName] = [p];
        }        
        return player;
    }
    

</script>
{#if sheet && sheet.home && sheet.visiting} 

{#if !guest && readonly}
    <a href="#" on:click={editIt}><Fa icon="{faPen}" size="3x"/></a>
{/if}
{#if !readonly && !guest}
<a href="#" on:click={(e) => saveMatchSheet(e)}><Fa icon={faFloppyDisk} size="3x"/></a>
<a href="#" on:click={(e) => cleanSheet(e)}><Fa icon={faBroom} size="3x"/></a>
{/if}

<table style="display:table !important; width: 100% !important; ">
{#if readonly || guest}
    <tr style="width:100% !important"><td colspan="2">{format(parse(sheet.date,'yyyy-MM-dd',new Date()),"dd / MM / yyyy")} </td><td colspan="14">{#if sheet.coupe}<Fa icon="{faTrophy}" color="tomato" size="2x"/>{/if}</td></tr>
{:else}
    <tr style="width:100% !important"><td colspan="2"><input type="date" bind:value={sheet.date}/></td><td colspan="13">
        <Fa icon="{faTrophy}" size="2x" color="{sheet.coupe ? 'tomato' : 'grey'}"/><Switch bind:checked={sheet.coupe}/>        
    </td></tr>
{/if}


{#if readonly || guest}

    <tr style="width:100% !important"><td colspan="8" style="text-align:center !important; font-weight:bolder">{sheet.home.name}</td>
    <td colspan="7" style="text-align:center !important; font-weight:bolder">{sheet.visiting.name}</td></tr>
{:else}
    <tr style="width:100% !important"><td colspan="8" style="text-align:center !important">
        <AutoComplete items="{teams}" 
                    bind:selectedItem="{sheet.home.name}" 
                    create={true} 
                    onCreate={(x) => { console.log(`add new home team ${x} - ${sheet.home.name}`);teams = [...teams,x]; return x}} 
                    onChange={() => {updateTeam('home');}}/>        
    </td>
    <td colspan="7" style="text-align:center !important">
        <AutoComplete items="{teams}" 
                    bind:selectedItem="{sheet.visiting.name}" 
                    create={true} 
                    onCreate={(x) => { console.log(`add new visiting team ${x} - ${sheet.visiting.name}`);teams = [...teams,x]; return x}} 
                    onChange={() => {updateTeam('visiting')}}/> 
    </td>
    </tr>
{/if}


<!-- players-->

<tr style="width:100% !important">
    {#if readonly || guest}
        <td>A</td><td colspan=5>{sheet.home.A.name}</td><td>{sheet.home.A.rank}</td>
        <td>&nbsp;</td>
        <td>X</td><td colspan=4>{sheet.visiting.X.name}</td><td  colspan=2>{sheet.visiting.X.rank}</td>
    {:else}
        <td>A</td>
        <td colspan=5>
            <AutoComplete items={homePlayers} 
                bind:selectedItem={sheet.home.A.name} 
                create={true} 
                onCreate={(x) => {return createPlayer(x, 'A', 'home')}}
                onChange={() => {updatePlayer("home","A",sheet.home.A.name)}}/>
        </td>            
        <td>
            <input type="number" bind:value={sheet.home.A.rank}/>
        </td>
        <td>&nbsp;</td>
        <td>X</td>
        <td colspan=4>
            <AutoComplete items={visitingPlayers} 
                bind:selectedItem={sheet.visiting.X.name} 
                create={true} 
                onCreate={(x) => {return createPlayer(x, 'X', 'visiting')}}
                onChange={() => {updatePlayer("visiting","X",sheet.visiting.X.name)}}/>
        </td><td colspan=2><input type="number" bind:value={sheet.visiting.X.rank}/></td>
    {/if}
</tr>
<tr style="width:100% !important">
    {#if readonly || guest}
        <td>B</td><td colspan=5>{sheet.home.B.name}</td><td>{sheet.home.B.rank}</td>
        <td>&nbsp;</td>
        <td>Y</td><td colspan=4>{sheet.visiting.Y.name}</td><td colspan=2>{sheet.visiting.Y.rank}</td>
    {:else}
        <td>B</td><td colspan=5><AutoComplete items={homePlayers} 
            bind:selectedItem={sheet.home.B.name} 
            create={true} 
            onCreate={(x) => {return createPlayer(x, 'B', 'home')}}
            onChange={() => {updatePlayer("home","B",sheet.home.B.name)}}/></td><td><input type="number" bind:value={sheet.home.B.rank}/></td>
        <td>&nbsp;</td>
        <td>Y</td><td colspan=4><AutoComplete items={visitingPlayers} 
            bind:selectedItem={sheet.visiting.Y.name} 
            create={true} 
            onCreate={(x) => {return createPlayer(x, 'Y', 'visiting');}}
            onChange={() => {updatePlayer("visiting","Y",sheet.visiting.Y.name)}}/></td><td colspan=2><input type="number" bind:value={sheet.visiting.Y.rank}/></td>
    {/if}
</tr>
<tr style="width:100% !important">
    {#if readonly || guest}
        <td>C</td><td colspan=5>{sheet.home.C.name}</td><td>{sheet.home.C.rank}</td>
        <td>&nbsp;</td>
        <td>Z</td><td colspan=4>{sheet.visiting.Z.name}</td><td  colspan=2>{sheet.visiting.Z.rank}</td>
    {:else}
        <td>C</td><td colspan=5><AutoComplete items={homePlayers} 
            bind:selectedItem={sheet.home.C.name} 
            create={true} 
            onCreate={(x) => {return createPlayer(x, 'C', 'home')}}
            onChange={() => {updatePlayer("home","C",sheet.home.C.name)}}/></td><td><input type="number" bind:value={sheet.home.C.rank}/></td>
        <td>&nbsp;</td>
        <td>Z</td><td colspan=4><AutoComplete items={visitingPlayers} 
            bind:selectedItem={sheet.visiting.Z.name} 
            create={true} 
            onCreate={(x) => {return createPlayer(x, 'Z', 'visiting')}}
            onChange={() => {updatePlayer("visiting","Z",sheet.visiting.Z.name)}}/></td><td colspan=2><input type="number" bind:value={sheet.visiting.Z.rank}/></td>
    {/if}
</tr>
<tr style="width:100% !important">
    {#if readonly || guest}
        <td>D</td><td colspan=5>{sheet.home.D.name}</td><td>{sheet.home.D.name ? sheet.home.D.rank : ''}</td>
        <td>&nbsp;</td>
        <td>W</td><td colspan=4>{sheet.visiting.W.name}</td><td  colspan=2>{sheet.visiting.W.name ? sheet.visiting.W.rank : ''}</td>
    {:else}
        <td>D</td><td colspan=5><AutoComplete items={homePlayers} 
            bind:selectedItem={sheet.home.D.name} 
            create={true} 
            onCreate={(x) => {return createPlayer(x, 'D', 'home')}}
            onChange={() => {updatePlayer("home","D",sheet.home.D.name)}}/></td><td><input type="number" bind:value={sheet.home.D.rank}/></td>
        <td>&nbsp;</td>
        <td>W</td><td colspan=4><AutoComplete items={visitingPlayers} 
            bind:selectedItem={sheet.visiting.W.name} 
            create={true} 
            onCreate={(x) => {return createPlayer(x, 'W', 'visiting')}}
            onChange={() => {updatePlayer("visiting","W",sheet.visiting.W.name)}}/></td><td colspan=2><input type="number" bind:value={sheet.visiting.W.rank}/></td>
    {/if}
</tr>

<!-- matches -->

<MatchSet incomplete={incompleteMatch('AX', sheet)} readonly={readonly || guest } homePlayer={sheet.home.A.name} visitingPlayer={sheet.visiting.X.name} bind:match={sheet.scores.AX}/>
<MatchSet incomplete={incompleteMatch('BY', sheet)} readonly={readonly} homePlayer={sheet.home.B.name} visitingPlayer={sheet.visiting.Y.name} bind:match={sheet.scores.BY}/>
<MatchSet incomplete={incompleteMatch('CZ', sheet)} readonly={readonly} homePlayer={sheet.home.C.name} visitingPlayer={sheet.visiting.Z.name} bind:match={sheet.scores.CZ}/>
<MatchSet incomplete={incompleteMatch('BX', sheet)} readonly={readonly} homePlayer={sheet.home.B.name} visitingPlayer={sheet.visiting.X.name} bind:match={sheet.scores.BX}/>
<MatchSetDouble bind:match={sheet.scores.Double}
                readonly={readonly} 
                bind:homePlayers={sheet.scores.double_home} bind:visitingPlayers={sheet.scores.double_visiting}
                homeTeam={sheet.home} visitingTeam={sheet.visiting}
                updateDoubles={updateDoubles}
                incomplete={incompleteDouble(sheet)}/>
{#if !readonly && ! guest} 
{/if}
<MatchSet incomplete={incompleteMatch('AZ', sheet)} readonly={readonly} homePlayer={sheet.home.A.name} visitingPlayer={sheet.visiting.Z.name} bind:match={sheet.scores.AZ}/>
<MatchSet incomplete={incompleteMatch('CY', sheet)} readonly={readonly} homePlayer={sheet.home.C.name} visitingPlayer={sheet.visiting.Y.name} bind:match={sheet.scores.CY}/>
<MatchSet incomplete={incompleteMatch('BZ', sheet)} readonly={readonly} homePlayer={sheet.home.B.name} visitingPlayer={sheet.visiting.Z.name} bind:match={sheet.scores.BZ}/>
<MatchSet incomplete={incompleteMatch('CX', sheet)} readonly={readonly} homePlayer={sheet.home.C.name} visitingPlayer={sheet.visiting.X.name} bind:match={sheet.scores.CX}/>
<MatchSet incomplete={incompleteMatch('AY', sheet)} readonly={readonly} homePlayer={sheet.home.A.name} visitingPlayer={sheet.visiting.Y.name} bind:match={sheet.scores.AY}/>
<tr style="width:100% !important"><td colspan="7">&nbsp;</td><td style="border-top: 2px solid black; font-weight: bold;">{total_home_score}</td><td colspan="6">&nbsp;</td><td style="border-top: 2px solid black; font-weight: bold;">{total_visiting_score}</td></tr>

</table>

{/if}
